import React from "react";

interface OveragePlanModalProps {
  show: boolean;
  overageCount: number;
  /** Plan type label shown in the overage message, e.g. "scanning plan subscription" */
  planLabel?: string;
  onConfirm: () => void;
  onCancel: () => void;
}

const OveragePlanModal: React.FC<OveragePlanModalProps> = ({
  show,
  overageCount,
  planLabel,
  onConfirm,
  onCancel,
}) => {
  if (!show) return null;

  return (
    <div className="modal d-block" tabIndex={-1} style={{ backgroundColor: "rgba(0,0,0,0.5)" }}>
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Are you sure you want to do this?</h5>
            <button type="button" className="btn-close" onClick={onCancel} />
          </div>
          <div className="modal-body">
            <p>
              Adding these phone numbers will exceed the number of records in your monthly plan by{" "}
              <strong>{overageCount} {planLabel ?? "plan subscription"}</strong> and you will be charged overage.
            </p>
          </div>
          <div className="modal-footer">
            <button className="btn btn-secondary" onClick={onCancel}>
              No
            </button>
            <button className="btn btn-primary" onClick={onConfirm}>
              Yes
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OveragePlanModal;
